import Compare from "../marketing/Compare";

export default function CompareWhoBrewVsPopl() {
  return (
    <Compare
      competitor="Popl"
      competitorUrl="https://popl.co"
      path="/compare/whobrew-vs-popl"
      seoTitle="WhoBrew vs Popl — honest comparison of NFC business cards"
      seoDescription="A side-by-side comparison of WhoBrew and Popl. Pricing, features, integrations, and where each one fits. No spin."
      positioning="Popl is the volume leader in NFC business cards and has pivoted upmarket to a GTM platform for in-person lead capture, with enterprise-shaped pricing and a sales-led demo funnel. WhoBrew is purpose-built for individual professionals and small teams who want a beautifully crafted card and honest analytics, without the seven-figure ACV motion."
      wedge={{
        headline: "Public pricing. Self-serve. No demo gate",
        italicWord: "demo",
        subhead:
          "Popl hides pricing behind a sales call because their growth motion needs the information asymmetry — they're optimized for landing six-figure RevOps deals at Fortune 500 sales orgs. WhoBrew is built for individuals and teams of fewer than fifty. We post the price because that's how people in our segment actually decide. You can ship a card in 60 seconds without speaking to a person.",
      }}
      outcomeStats={[
        {
          label: "Time to first live card",
          whobrew: "60s",
          competitor: "Demo required, days",
          context: "Sign up, claim handle, ship card.",
        },
        {
          label: "Year 1 cost · 1 user · 1 NFC card",
          whobrew: "$74",
          competitor: "Quote-only; reports place it in four-figure ranges",
          context: "$59.88 Pro + $14.99 PVC card.",
        },
        {
          label: "Lead capture · analytics",
          whobrew: "Included",
          competitor: "Bundled on top tiers; CRM integrations are additional config",
          context: "Custom contact forms, per-link clicks, sources.",
        },
      ]}
      rows={[
        { feature: "Free tier", whobrew: "Free forever",        competitor: "14-day trial only" },
        { feature: "Starting paid plan", whobrew: "$4.99 / month",  competitor: "Demo required" },
        { feature: "Public pricing",       whobrew: true,             competitor: false },
        { feature: "NFC card",             whobrew: "$14.99 once",    competitor: "$10–$50" },
        { feature: "Cards per account",    whobrew: "Up to 3 (Pro)",  competitor: "Unlimited (paid)" },
        { feature: "Lead capture form",    whobrew: true,             competitor: true },
        { feature: "Custom contact-form fields", whobrew: "Up to 4 per link (Pro)", competitor: "Standard fields" },
        { feature: "CSV export",           whobrew: true,             competitor: true },
        { feature: "Salesforce / HubSpot integration", whobrew: "On roadmap",  competitor: true },
        { feature: "Themes",               whobrew: "11 included",    competitor: "Custom (paid)" },
        { feature: "Owner-friendly product", whobrew: "Self-serve",   competitor: "Sales-led" },
      ]}
      whereTheyWin="Popl genuinely has the deepest enterprise feature set in the category — direct CRM integrations, badge scanning at large events, and an account team that can wire everything into a Salesforce instance for a 200-person sales org. If you're a Fortune 500 RevOps team running events at scale and you need vendor procurement to sign off on the card you hand out, Popl is the right answer. They've earned that position."
      recommendation="Pick Popl if you're a large enterprise sales or events team that wants integrations done by an account manager and doesn't mind paying for the help. Pick WhoBrew if you're an individual professional, a founder, or a team of fewer than fifty who wants honest pricing on the homepage and a product you can spin up without a sales call."
    />
  );
}
